module.exports = __webpack_public_path__ + "media/images/throw-away-193b9f816ba4bfa0d9247c803939c93a.svg";